export interface DateFilterRange {
    dateRangeType: number;
    start: string;
    end: string
}

export const InitialDateFilterRange: DateFilterRange = {
    dateRangeType: 0,
    start: new Date().toISOString(),
    end: new Date().toISOString()
}